import { combineReducers } from 'redux'

// ACTIONS
export const FETCH = 'company/candidateDetails/positions/FETCH'
export const FETCH_SUCCESS = 'company/candidateDetails/positions/FETCH_SUCCESS'

export const TOGGLE_LOADING = 'company/candidateDetails/positions/TOGGLE_LOADING'

export const RESET = 'company/candidateDetails/positions/RESET'

// ACTION CREATORS
export const toggleLoading = loading => ({
  type: TOGGLE_LOADING,
  payload: { loading },
})

export const fetch = (hiring_team_id, params) => ({
  type: FETCH,
  payload: {
    hiring_team_id,
    params: {
      archived: false,
      order_by: 'updated_at',
      order_direction: 'desc',
      items_per_page: defaultPagination.items_per_page,
      ...params,
    },
  },
})

export const fetchSuccess = ({ result, pagination_info }) => ({
  type: FETCH_SUCCESS,
  payload: {
    collection: [...result],
    pagination_info,
  },
})

export const reset = () => ({
  type: RESET,
})

// REDUCERS
const defaultUtils = {
  loading: true,
  error: null,
}

const utils = (state = defaultUtils, { type, payload }) => {
  switch (type) {
    case TOGGLE_LOADING:
      return {
        ...state,
        ...payload,
      }

    case RESET:
      return defaultUtils

    default:
      return state
  }
}

const collection = (state = [], { type, payload }) => {
  switch (type) {
    case FETCH_SUCCESS:
      return [...payload.collection]

    case RESET:
      return []

    default:
      return state
  }
}

const defaultPagination = {
  current_page: 0,
  total_pages: 0,
  items_per_page: 20,
  total_items: 0,
}

const pagination = (state = defaultPagination, { type, payload }) => {
  switch (type) {
    case FETCH_SUCCESS:
      return {
        ...state,
        ...payload.pagination_info,
      }

    case RESET:
      return defaultPagination

    default:
      return state
  }
}

export default combineReducers({
  utils,
  collection,
  pagination,
})
